import { SIZE } from 'assets/styles/ScreenSize';
import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS } from 'utils/styles/fonts';

export const Button = styled.button`
  background: ${({ isChooseAnswer }) =>
    isChooseAnswer ? 'transparent' : COLORS.mainColor};
  color: ${({ isChooseAnswer }) =>
    isChooseAnswer ? COLORS.mainColor : COLORS.white};
  border-radius: 10px;
  border: 2px solid ${COLORS.mainColor};
  margin-left: 20px;

  @media (min-width: ${SIZE.mobile}) {
    ${FONTS.font12}
    width: 116px;
    height: 36px;
    margin-left: 0;
  }

  @media (min-width: ${SIZE.iphone}) {
    width: 140px;
    height: 46px;
    ${FONTS.font14}
    margin-left: 0;
  }

  @media (min-width: ${SIZE.tablet}) {
    width: 152px;
    height: 40px;
    ${FONTS.font16}
    margin-left: 36px;
  }

  @media (min-width: ${SIZE.desktop}) {
    width: 146px;
    height: 40px;
    margin-left: 30px;
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    width: 174px;
    height: 48px;
    margin-left: 58px;
  }
`;

export const StyledButtonsWrapper = styled.div`
  margin-top: 100px;
  ${({ closeButton }) =>
    closeButton ? FLEX_CONTAINER.FlexEndRow : FLEX_CONTAINER.FlexCenterRow}
  width: 100%;

  @media (max-width: ${SIZE.tablet}) {
    justify-content: center;
    column-gap: 20px;
  }
`;

export const StyledColesButton = styled.button`
  border-radius: 10px;
  border: 2px solid ${COLORS.mainColor};
  width: 150px;
  height: 50px;
  color: ${COLORS.mainColor};

  @media (min-width: ${SIZE.mobile}) {
    margin-bottom: 26px;
  }

  @media (min-width: ${SIZE.tablet}) {
    margin-bottom: 14px;
  }

  @media (min-width: ${SIZE.desktop}) {
    margin-bottom: 0;
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    margin-bottom: 0;
  }
`;
